export default __webpack_public_path__ + "static/media/lancer-depannage.cc9fd906.jpg";